import UserWithdraw from 'components/UserWithdraw/UserWithdraw';

const UserWithdrawPage = () => {
	return <UserWithdraw />;
};

export default UserWithdrawPage;
